function countLeadingSpaces(line: string): number {
  const match = line.match(/^( *)/);
  return match ? match[0].length : 0;
}

const strUtil = {
  // Returns whether string needle is in string haystack, case insensitive.
  caseInsensitiveContains: (haystack: string, needle: string): boolean =>
    haystack.toLowerCase().indexOf(needle.toLowerCase()) !== -1,

  isEmpty: (value: string): boolean => value.trim().length === 0,

  // Validates email contains an @ and . -- we don't do more robust validation since email validation
  // is futile.
  isValidEmail: (email: string): boolean => /.+@.+\..+/.test(email),

  isValidUrl: (url?: string | null): url is string => url != null && url.length > 0,

  dedent: (s: string): string => {
    // Mimics Python's textwrap.dedent library function (remove common leading spaces from each line)
    const lines = s.split('\n');
    const sharedLeadingSpaces = Math.min(...lines.map((line) => countLeadingSpaces(line)));
    const spaceString = ' '.repeat(sharedLeadingSpaces);

    return lines.map((line) => line.replace(spaceString, '')).join('\n');
  },

  ensureTrailingPeriod: (text: string): string => {
    // Normalize the string to end with a period. Use in case we want to append another sentence.
    const trimmedText = text.trimEnd();
    if (trimmedText.length === 0 || trimmedText.endsWith('.')) {
      return trimmedText;
    }
    return `${trimmedText}.`;
  },

  toSentenceCase: (text: string): string =>
    text.length > 1 ? text[0].toUpperCase() + text.slice(1).toLowerCase() : '',

  getReadableStringFromList: (elements: Array<string>): string => {
    if (elements.length === 0) {
      return '';
    } else if (elements.length === 1) {
      return elements[0];
    } else if (elements.length === 2) {
      return `${elements[0]} and ${elements[1]}`;
    }
    return `${elements.slice(0, elements.length - 1).join(', ')}, and ${elements[elements.length - 1]}`;
  },
};

export default strUtil;
